import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ShippingMethodInfo } from "../../../../../../../modules/ShippingMethods/components/StepShipping/modules/ShippingMethods/components/ShippingMethodInfo.js";
import { useShippingMethodsList } from "../../../../../../../modules/ShippingMethods/hooks/StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { mapShippingMethods } from "../../../../../../../../mappers/view/mappers/view/shipping-methods.js";
const useGroupedShippingMethods = (allowedKeys, onShippingMethodsLoadCompleted) => {
  const { locale } = useIntl();
  const { shippingMethodsLogos } = useCheckoutSettings();
  const { shippingMethodList, isLoading, error } = useShippingMethodsList(
    onShippingMethodsLoadCompleted
  );
  const shippingMethodInfo = ({ price, logo, isFree }) => /* @__PURE__ */ React.createElement(ShippingMethodInfo, { price, logo, isFree });
  const items = mapShippingMethods({
    logos: shippingMethodsLogos,
    locale,
    shippingMethodList,
    shippingMethodInfo
  });
  return {
    groupedShippingMethods: React.useMemo(
      () => items.filter((item) => allowedKeys.includes(item.value)),
      [allowedKeys, items]
    ),
    error,
    isLoading
  };
};
export {
  useGroupedShippingMethods
};
//# sourceMappingURL=use-grouped-shipping-methods.js.map
